module.exports = __webpack_public_path__ + "img/20210224.807484c7.gif";